let databaseCache = null;

export default {
  namespaced: true,
  state: {
    // Database state
    postalDatabase: [],
    provincesDatabase: [],
    districtsDatabase: [],
    subdistrictsDatabase: []
  },
  getters: {
    // Database getters
    postalDatabase(state) {
      return state.postalDatabase;
    },
    provincesDatabase(state) {
      return state.provincesDatabase;
    },
    districtsDatabase(state) {
      return state.districtsDatabase;
    },
    subdistrictsDatabase(state) {
      return state.subdistrictsDatabase;
    }
  },
  mutations: {
    // Database mutations
    setPostalDatabase(state, data) {
      state.postalDatabase = data;
    },
    setProvincesDatabase(state, data) {
      state.provincesDatabase = data;
    },
    setDistrictsDatabase(state, data) {
      state.districtsDatabase = data;
    },
    setSubdistrictsDatabase(state, data) {
      state.subdistrictsDatabase = data;
    }
  },
  actions: {
    // Database actions
    async loadPostalDatabase({ commit }) {
      try {
        if (databaseCache) {
          commit('setPostalDatabase', databaseCache.postalData || []);
          return { status: true };
        }

        const response = await fetch('https://proship-dev.s3.ap-southeast-1.amazonaws.com/raw_database.json');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        
        databaseCache = data;
        commit('setPostalDatabase', data.postalData || []);
        return { status: true };
      } catch (error) {
        console.error('Error loading postal database:', error);
        return { status: false, error };
      }
    },

    async loadEnglishMappings({ commit }) {
      try {
        if (databaseCache) {
          commit('setProvincesDatabase', databaseCache.provinces || []);
          commit('setDistrictsDatabase', databaseCache.districts || []);
          commit('setSubdistrictsDatabase', databaseCache.subdistricts || []);
          return { status: true };
        }

        const response = await fetch('https://proship-dev.s3.ap-southeast-1.amazonaws.com/raw_database.json');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        
        databaseCache = data;
        commit('setProvincesDatabase', data.provinces || []);
        commit('setDistrictsDatabase', data.districts || []);
        commit('setSubdistrictsDatabase', data.subdistricts || []);
        return { status: true };
      } catch (error) {
        console.error('Error loading English mappings:', error);
        return { status: false, error };
      }
    }
  }
};
